<template>
  <div class="detail-container">
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>采购汇总表明细</span>
      </div>
      <el-button size="small" icon="el-icon-back" @click="goBack">返回采购汇总表</el-button>
    </div>

    <div class="scope-tip" v-if="scopeSupplierName">
      <span>供应商：{{ scopeSupplierName }}</span>
    </div>

    <div class="search-area">
      <el-date-picker
        v-model="startDate"
        type="date"
        placeholder="查询时间起"
        aria-label="查询时间起"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input date-picker"
      ></el-date-picker>
      <el-date-picker
        v-model="endDate"
        type="date"
        placeholder="查询时间止"
        aria-label="查询时间止"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input date-picker"
      ></el-date-picker>
      <el-select
        v-model="selectedSupplierNames"
        multiple
        filterable
        placeholder="供应商（多选）"
        class="search-input select-multi"
        clearable
      >
        <el-option
          v-for="item in supplierNameOptions"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <el-select
        v-model="selectedContractNames"
        multiple
        filterable
        placeholder="合同名称（多选）"
        class="search-input select-multi"
        clearable
      >
        <el-option
          v-for="item in contractNameOptions"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
      <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
      <el-button v-permission="'statistics:settlement-purchase:export'" type="warning" @click="handleExport" icon="el-icon-download" :loading="exportLoading">导出</el-button>
    </div>

    <div class="table-area">
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column prop="supplierUnitNames" label="供应商" min-width="160" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contractNames" label="合同名称" min-width="160" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purchaseAmount" label="采购金额" width="120" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.purchaseAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="settlementAmount" label="结算金额" width="120" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.settlementAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="settlementDate" label="结算时间" width="170" align="center">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.settlementDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="settlementNumber" label="结算单号" min-width="140" align="center"></el-table-column>
        <el-table-column label="附件" width="120" align="center">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.attachmentCount > 0 && scope.row.attachments && scope.row.attachments.length"
              placement="left"
              trigger="hover"
              width="280"
            >
              <div class="attachment-popover">
                <div
                  v-for="att in scope.row.attachments"
                  :key="att.id"
                  class="attachment-row"
                >
                  <el-button v-permission="'statistics:settlement-purchase:download-attachment'" type="text" class="attachment-link" @click="downloadAttachment(att)">
                    {{ att.originalName }}
                  </el-button>
                </div>
              </div>
              <span slot="reference" class="attachment-count">{{ scope.row.attachmentCount }} 个附件</span>
            </el-popover>
            <span v-else>0</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { download_settlement_attachment } from '@/api/modules/settlement-attachment'

export default {
  name: 'SettlementPurchaseSummaryDetail',
  data() {
    return {
      scopeSupplierName: '',
      startDate: '',
      endDate: '',
      selectedSupplierNames: [],
      selectedContractNames: [],
      supplierNameOptions: [],
      contractNameOptions: [],
      loading: false,
      exportLoading: false,
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.initFromRoute()
    if (!this.scopeSupplierName) {
      this.$message.warning('请从采购汇总表点击「查看明细」进入，或检查链接参数')
    }
    this.loadFilterOptions()
    this.loadData()
  },
  methods: {
    initFromRoute() {
      const q = this.$route.query
      this.scopeSupplierName = (q.scopeSupplierName && String(q.scopeSupplierName)) || ''
      this.startDate = q.startDate || ''
      this.endDate = q.endDate || ''
      try {
        if (q.spFj) {
          this.selectedSupplierNames = JSON.parse(decodeURIComponent(q.spFj))
        }
        if (q.cnFj) {
          this.selectedContractNames = JSON.parse(decodeURIComponent(q.cnFj))
        }
      } catch (e) {
        this.selectedSupplierNames = []
        this.selectedContractNames = []
      }
    },
    goBack() {
      this.$router.push({ name: 'SettlementPurchaseSummary' })
    },
    loadFilterOptions() {
      api.statistics.getSettlementPurchaseSummaryFilterOptions()
        .then(response => {
          if (response.data && response.data.success) {
            const options = response.data.data || {}
            this.supplierNameOptions = options.supplierUnitNames || []
            this.contractNameOptions = options.contractNames || []
          }
        })
        .catch(() => {})
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleReset() {
      this.startDate = ''
      this.endDate = ''
      this.selectedSupplierNames = []
      this.selectedContractNames = []
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    handleExport() {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        this.$message.warning('查询时间起不能晚于查询时间止')
        return
      }
      if (!this.scopeSupplierName) {
        this.$message.warning('缺少汇总范围供应商，无法导出')
        return
      }
      this.exportLoading = true
      const params = {
        scopeSupplierName: this.scopeSupplierName
      }
      if (this.startDate) params.startDate = this.startDate
      if (this.endDate) params.endDate = this.endDate
      if (this.selectedSupplierNames && this.selectedSupplierNames.length > 0) {
        params.supplierUnitNames = this.selectedSupplierNames
      }
      if (this.selectedContractNames && this.selectedContractNames.length > 0) {
        params.contractNames = this.selectedContractNames
      }
      api.statistics.exportSettlementPurchaseSummaryDetail(params)
        .then(response => {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = response.headers['content-disposition']
          let fileName = '采购汇总表明细.xlsx'
          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=([^;]+)/i)
            if (match) {
              fileName = decodeURIComponent(match[1].replace(/^UTF-8''/, '').trim())
            }
          }
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.$message.success('导出成功')
        })
        .catch(err => {
          this.$message.error(err.response?.data?.message || '导出失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    formatAmount(amount) {
      if (amount === undefined || amount === null) return '0.00'
      return Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    formatDateTime(val) {
      if (!val) return ''
      const s = String(val).replace('T', ' ')
      return s.length > 19 ? s.slice(0, 19) : s
    },
    downloadAttachment(attachment) {
      download_settlement_attachment(attachment.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.download = attachment.originalName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
        .catch(() => {
          this.$message.error('下载失败')
        })
    },
    loadData() {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        this.$message.warning('查询时间起不能晚于查询时间止')
        return
      }
      if (!this.scopeSupplierName) {
        this.tableData = []
        this.pagination.total = 0
        return
      }
      this.loading = true
      const params = {
        page: this.pagination.currentPage - 1,
        size: this.pagination.pageSize,
        scopeSupplierName: this.scopeSupplierName
      }
      if (this.startDate) params.startDate = this.startDate
      if (this.endDate) params.endDate = this.endDate
      if (this.selectedSupplierNames && this.selectedSupplierNames.length > 0) {
        params.supplierUnitNames = this.selectedSupplierNames
      }
      if (this.selectedContractNames && this.selectedContractNames.length > 0) {
        params.contractNames = this.selectedContractNames
      }
      api.statistics.getSettlementPurchaseSummaryDetail(params)
        .then(response => {
          if (response.data && response.data.success) {
            const data = response.data.data || {}
            this.tableData = data.content || []
            this.pagination.total = data.totalElements || 0
          } else {
            this.tableData = []
            this.$message.error(response.data?.message || '获取明细失败')
          }
        })
        .catch(err => {
          this.tableData = []
          this.$message.error(err.response?.data?.message || '获取明细失败')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-container {
  padding: 20px;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.header-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}
.title-mark {
  width: 4px;
  height: 18px;
  background: #409eff;
  margin-right: 10px;
}
.scope-tip {
  margin-bottom: 16px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}
.search-area {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.search-input {
  width: 200px;
}
.select-multi {
  min-width: 200px;
  max-width: 280px;
}
.date-picker {
  width: 200px;
}
.table-area {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
.attachment-count {
  color: #409eff;
  cursor: default;
  text-decoration: underline;
}
.attachment-popover {
  max-height: 240px;
  overflow-y: auto;
}
.attachment-row {
  line-height: 1.8;
}
.attachment-link {
  padding: 0;
  white-space: normal;
  text-align: left;
}
::v-deep .el-table th {
  background-color: #f5f7fa !important;
  color: #606266 !important;
  font-weight: 600;
}
</style>
